<template>
  <div class="login">
    <!-- 头部 -->
    <LoginHeader />
    <!-- 主体 -->
    <LoginMain />
    <!-- 底部 -->
    <Footer />
    <!-- 固定侧边栏 -->
    <TipBar />
  </div>
</template>

<script>
import LoginMain from './components/LoginMain.vue'
export default {
  components: {
    LoginMain
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="less">
.login {
  width: 100vw;
  height: 100vh;
  min-width: 1360px;
  font-family: PingFangSC-Light, PingFang SC;
}
</style>
